import { render, staticRenderFns } from "./AnnouncementAlert.vue?vue&type=template&id=1b7a580b"
import script from "./AnnouncementAlert.vue?vue&type=script&lang=js"
export * from "./AnnouncementAlert.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementAlert.vue?vue&type=style&index=0&id=1b7a580b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports